import cn from 'classnames';
import { useMemo } from 'react';
import { Select } from '@framework/ui/Organisms/FinalForm/Fields/Select';
import { Field, useField } from '@framework/ui/Organisms/FinalForm';
import { usePortfolioMonitorContext } from '@/creditflowresearch/application/PortfolioMonitor/PortfolioMonitorContext';
import {
  PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY,
} from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/FormSteps/OptionalData/constants';
import Input from '@creditflowresearch/uilib/Input';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import IconTrash from '@creditflowresearch/uilib/Icon/IconTrash';
import {
  IFinalFormFieldInputComponentProps,
} from '@framework/ui/Organisms/FinalForm/interfaces';
import {
  useConfirmDeletePositionContext,
} from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/ConfirmDeletePositionContext/ConfirmDeletePositionContext';

import styles from
    '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/FormSteps/OptionalData/styles.module.scss';
import spaces from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface ICurrencyCellProps {
  rowIndex: number,
  cellName: string,
  isDisabled: boolean,
}

interface IInputCellProps {
  rowIndex: number,
  cellName: string,
  params: Partial<IFinalFormFieldInputComponentProps>,
  format: (inputValue: string) => void,
}

export const OptionalDataCurrencyCell = (props: ICurrencyCellProps) => {
  const {
    rowIndex,
    cellName,
    isDisabled,
  } = props;
  const { currencies: { collection } } = usePortfolioMonitorContext();

  const currenciesOptions = useMemo(() => collection.map((option) => ({
    value: option.id,
    label: option.displayName,
  })), [collection.length]);

  return (
    <Field
      name={ `${ PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY }[${ rowIndex }].${ cellName }` }
      placeholder="USD"
      formFieldClassName={ cn(spaces.mbn, styles.currencyCell) }
      className={ cn(styles.formInputWrp, styles.formInputWrpSmall) }
      component={ Select }
      dataTest={ cellName }
      simpleValue
      options={ currenciesOptions }
      isDisabled={ isDisabled }
    />
  );
};

export const OptionalDataInputCell = (props: IInputCellProps) => {
  const {
    cellName,
    rowIndex,
    params,
    format,
  } = props;
  const { meta } = useField(`${ PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY }[${ rowIndex }].${ cellName }`);

  return (
    <Tooltip
      content={ meta.error }
      containerClassName={ styles.errorTooltipContainer }
      className={ meta.error ? '' : styles.disabledTooltip }
      type="error"
      offsetOptions={ {
        mainAxis: 1,
      } }
    >
      <Field
        name={ `${ PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY }[${ rowIndex }].${ cellName }` }
        placeholder="1,000,000"
        formFieldClassName={ cn(spaces.mbn, styles.inputField) }
        inputClassName={ { [styles.inputFieldError]: meta.error } }
        dataTest={ cellName }
        component={ Input }
        format={ format }
        isErrorMessage={ false }
        { ...params }
      />
    </Tooltip>
  );
};

export const ActionsCell = (props: { rowIndex: number }) => {
  const { rowIndex } = props;
  const { handleDeletePosition } = useConfirmDeletePositionContext();

  return (
    <IconButton
      icon={ <IconTrash /> }
      dataTest="portfolioCusipListDeleteButton"
      onClick={ () => handleDeletePosition(rowIndex) }
      color="primary"
      ariaLabel="Delete position"
    />
  );
};
